<div class='ipensii-translucent-card' [style]='style'>
  <ng-content></ng-content>
</div>
